import axios from "axios";

export default {
  strict: true,
  namespaced: true,
  state: {
    memberInvites: [],
  },
  actions: {
    init: async ({ commit }) => {
      const inviteResponse = await axios.get("/businesses/member-invite");
      commit("setMemberInvites", inviteResponse.data);
    },
  },
  mutations: {
    setMemberInvites(state, payload) {
      state.memberInvites = payload;
    },
    clearMemberInvites(state) {
      state.memberInvites = [];
    },
  },
};
